module.exports = __webpack_public_path__ + "img/tile-rendering-desktop_en.fb701cb.jpg";